import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/components.css";
import "./styles/layout.css";
import "./styles/wave2.css";
import "./styles/wave3.css";
import "./styles/agents.css";
import "./styles/wave5.css";
import "./styles/routing.css";
import "./styles/assistant.css";
import "./styles/blocks.css";
import "./styles/composer.css";
import "./styles/microsystem.css";
import "./styles/integrations-panel.css";
import "./styles/shell.css";
import { App } from "./App.tsx";

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root element");
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
